import React, { useState } from 'react';
import { Box, Card } from '@mui/material';
import { DialogForm, IDialogActions, ISnackbarAlert, SnackbarAlert } from '../../../shared/components';
import { useTheme } from '@mui/material/styles';
import { TestAcceptanceCriteria } from './TestAcceptanceCriteria';

interface ITestAcceptanceCriteriaViewDialogProps {
    data: any;
    parentId?: string;
    setIsOpenMaintenance: (value: boolean) => void;
    isOpenMaintenance: boolean;
    setActionExecuted: (value: true) => void;
}

export const TestAcceptanceCriteriaViewDialog: React.FC<ITestAcceptanceCriteriaViewDialogProps> = ({ data, parentId, isOpenMaintenance, setIsOpenMaintenance, setActionExecuted }) => {

    const [loading, setLoading] = useState(false);

    const theme = useTheme();

    const actions: IDialogActions[] = [
        { id: 'close', text: 'Close', icon: 'cancel_outlined', iconColor: 'secondary', setAction: () => void undefined },
    ];
    return (
        <React.Fragment>
            <DialogForm
                title='TEST ACCEPTANCE CRITERIA LIST VIEW'
                icon='offline_pin_outlined'
                setIsOpen={setIsOpenMaintenance}
                isOpen={isOpenMaintenance}
                fullWidth={true}
                maxWidth={'xl'}
                actions={actions}
                loading={loading}
            >
                <React.Fragment>
                    <Card sx={{ bgcolor: theme.palette.background.default, p: 1, width: '100%' }}>
                        <Box sx={{ display: 'flex', width: '100%', overflow: 'hidden', overflowY: 'auto' }}>
                            <TestAcceptanceCriteria
                                data={data}
                                testScenarioId={parentId}
                            />
                        </Box>
                    </Card>
                </React.Fragment>
            </DialogForm>
        </React.Fragment>
    );
};